<template>
  <!-- 审批按钮 -->
  <div >
    <!--拒绝的弹窗-->
    <a-modal
      title="审核驳回"
      :visible="visible"
      @ok="confirm"
      @cancel="visible=false"
      :confirmLoading="btnLoading.loading"
      okText="确认"
      cancelText="取消"
      destroyOnClose
      centered
      :maskClosable="false"
      :keyboard="false"
    >
      <a-form :form="modalForm">
        <a-form-item v-bind="$store.state.modal_ItemLayout" label="驳回模块">
          <!-- <a-textarea v-decorator="['checkRemark', decoratorOptions.checkRemark]" placeholder="请输入至少5个字符"></a-textarea> -->
          <a-select
            mode="multiple"
            style="width: 100%"
            placeholder="请选择模块"
            option-label-prop="label"
            v-decorator="['rejectModel', decoratorOptions.rejectModel]"
          >
            <a-select-option  v-for="(item, index) of option" :key="index" :value="item.id" :label="item.label">
              {{item.label}}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item v-bind="$store.state.modal_ItemLayout" label="驳回原因">
          <a-textarea v-decorator="['checkRemark', decoratorOptions.checkRemark]" placeholder="请输入至少5个字符"></a-textarea>
        </a-form-item>
      </a-form>
    </a-modal>
    <div class="bottom_banner">
       <a-button @click="visible = true" style='margin-right:20px;'>驳回</a-button>
        <a-button type="primary" @click="pass" style='margin-right:20px;'>通过</a-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'approvalModel',
  props: ['id', 'option'],
  data () {
    return {
      value: undefined,
      visible: false,
      btnLoading: { loading: false },
      decoratorOptions: {
        rejectModel: {
          rules: [
            { required: true, message: '请选择驳回模块' }
          ]
        },
        checkRemark: {
          rules: [
            { required: true, message: '请输入驳回原因' },
            { min: 5, message: '驳回原因最少5个字' },
            {pattern: /^([\s]*[\S]+[\s]*[\S]*)+$/, message: '不能为空'}
          ]
        }
      }

    };
  },
  beforeCreate () {
    this.modalForm = this.$form.createForm(this);
  },
  created () {
  },
  methods: {
    show () {
      this.visible = true;
    },
    /* 点击通过按钮 */
    pass () {
      this.$confirm({
        title: '确定通过审核？',
        centered: true,
        onOk: () => {
          this.$emit('pass');
        }
      });
    },
    /* 点击确定弹窗 */
    confirm () {
      this.modalForm.validateFields((err, values) => {
        if (err) { return false; }
        this.$emit('reject', values.checkRemark, values.rejectModel);
      });
    }
  }
};
</script>

<style scoped>
.bottom_banner{
  padding:16px 20px;
  text-align: right;
  position: fixed;
  bottom: 0;
  width: calc(100% - 248px);
  height: 60px;
  margin-left: -20px;
  background: white;
  z-index: 999;
}
</style>
